import { render, staticRenderFns } from "./Funnel.vue?vue&type=template&id=db52c786&scoped=true&"
import script from "./Funnel.vue?vue&type=script&lang=js&"
export * from "./Funnel.vue?vue&type=script&lang=js&"
import style0 from "./Funnel.vue?vue&type=style&index=0&id=db52c786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db52c786",
  null
  
)

export default component.exports